<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="detailDialog"
        persistent
        max-width="600px"
        scrollable
      >
        <v-card style="border-radius: 8px">
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            >
              <span class="headline">Export Order Detail</span>
            </v-flex>
            <v-flex xs1>
              <v-btn
                flat
                icon
                class="close"
                @click="$emit('close')"
              >
                <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
              </v-btn>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <div
              v-if="instance.image"
              style="width: 150px; height: 150px; border: 1px solid #ccc; margin-bottom: 10px; border-radius: 6px"
            >
              <a
                :href="`${$_image_path()}${instance.image}`"
                target="_blank"
              >
                <img
                  :src="`${$_image_path()}${instance.image}`"
                  alt="Product Image"
                  style="width: 100%; height: 100%; object-fit: contain"
                />
              </a>
            </div>
            <table class="detail-table">
              <tbody>
                <tr>
                  <td class="section-title">Order Info</td>
                </tr>
                <tr>
                  <td><b>Order Number</b></td>
                  <td>{{ instance.order_number }}</td>
                </tr>
                <tr>
                  <td><b>Customer Name</b></td>
                  <td>{{ instance.customer.full_name }}</td>
                </tr>
                <tr>
                  <td><b>Customer Note</b></td>
                  <td>{{ instance.customer.customer_note }}</td>
                </tr>
                <tr>
                  <td><b>Customer Phone</b></td>
                  <td>{{ instance.customer.phone_number }}</td>
                </tr>
                <tr>
                  <td><b>Product Name</b></td>
                  <td>{{ instance.product_name }}</td>
                </tr>
                <tr>
                  <td><b>Quantity</b></td>
                  <td>{{ instance.quantity }}</td>
                </tr>
                <tr v-if="instance.weight">
                  <td><b>Weight</b></td>
                  <td>{{ instance.weight }} {{ instance.weight ? instance.weight_unit : '' }}</td>
                </tr>
                <tr v-if="instance.volume_l">
                  <td><b>Volume (L)</b></td>
                  <td>{{ instance.volume_l }}</td>
                </tr>
                <tr v-if="instance.volume_w">
                  <td><b>Volume (W)</b></td>
                  <td>{{ instance.volume_w }}</td>
                </tr>
                <tr v-if="instance.volume_h">
                  <td><b>Volume (H)</b></td>
                  <td>{{ instance.volume_h }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title">Price Info</td>
                </tr>
                <tr>
                  <td><b>Shipping</b></td>
                  <td>{{ instance.shipping | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>International Tax</b></td>
                  <td>{{ instance.national_tax | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>Delivery</b></td>
                  <td>{{ instance.delivery_price | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>Discount</b></td>
                  <td>{{ instance.discount | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>Price</b></td>
                  <td>{{ instance.price | usdFormat }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title">Status Info</td>
                </tr>
                <tr>
                  <td><b>Status</b></td>
                  <td>
                    <span
                      style="border-radius: 6px; text-transform: capitalize; font-size: 11px"
                      class="label px-2"
                      :class="{
                      'bg-orange-600': instance.status === 1,
                      'bg-indigo-600': instance.status === 2,
                      'bg-danger-600': instance.status === 3,
                      'bg-green-600': instance.status === 4,
                      'bg-primary-600': instance.status === 5,
                      'bg-teal-600': instance.status === 6
                    }"
                    >
                      {{ instance.status_text }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><b>Ordered At</b></td>
                  <td>{{ instance.created_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.canceled_at">
                  <td><b>Canceled At</b></td>
                  <td>{{ instance.canceled_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.canceled_by">
                  <td><b>Canceled By</b></td>
                  <td>{{ instance.canceled_by ? instance.canceled_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.approved_at">
                  <td><b>Approved At</b></td>
                  <td>{{ instance.approved_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.approved_by">
                  <td><b>Approved By</b></td>
                  <td>{{ instance.approved_by ? instance.approved_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.sent_at">
                  <td><b>Sent At</b></td>
                  <td>{{ instance.sent_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.sent_by">
                  <td><b>Sent By</b></td>
                  <td>{{ instance.sent_by ? instance.sent_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.received_at">
                  <td><b>Received At</b></td>
                  <td>{{ instance.received_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.received_by">
                  <td><b>Received By</b></td>
                  <td>{{ instance.received_by ? instance.received_by.full_name : '' }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title">Receiver Info</td>
                </tr>
                <tr>
                  <td><b>Name</b></td>
                  <td>{{ instance.receiver_name }}</td>
                </tr>
                <tr>
                  <td><b>Phone</b></td>
                  <td>{{ instance.receiver_phone }}</td>
                </tr>
                <tr>
                  <td><b>Email</b></td>
                  <td>{{ instance.receiver_email }}</td>
                </tr>
                <tr>
                  <td><b>Country</b></td>
                  <td>{{ instance.to_country ? instance.to_country.country_name : '' }}</td>
                </tr>
                <tr>
                  <td><b>City</b></td>
                  <td>{{ instance.receiver_city }}</td>
                </tr>
                <tr>
                  <td><b>Address</b></td>
                  <td>{{ instance.receiver_address }}</td>
                </tr>
                <tr>
                  <td><b>ZIP Code</b></td>
                  <td>{{ instance.receiver_zip_code }}</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="$emit('close')"
              outline
              small
              class="py-1 px-2"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'detailDialog',
    'instance'
  ]
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.detail-table .section-title {
  padding-left: 0px;
  padding-top: 0px;
  opacity: 0.7;
}

.detail-table tr td {
  padding: 3px 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/exportOrder/viewExportOrderDetails.vue